
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { list_type, bool_type, float64_type, record_type, int32_type, option_type, string_type, class_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { ofArray, tryFind, singleton } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export class TelematicsProvider extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["TelematicOne"];
    }
}

export function TelematicsProvider_$reflection() {
    return union_type("Shared.Telematics.TelematicsProvider", [], TelematicsProvider, () => [[]]);
}

export function TelematicsProvider__get_Key(this$) {
    return "telematic_one";
}

export function TelematicsProvider__ToI18nString(this$) {
    return concat("telematics.provider.", ...TelematicsProvider__get_Key(this$));
}

export const TelematicsProviderModule_all = singleton(new TelematicsProvider());

export function TelematicsProviderModule_tryParse(key) {
    return tryFind((provider) => (TelematicsProvider__get_Key(provider) === key), TelematicsProviderModule_all);
}

export class TrackerEntityType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "Set"];
    }
}

export function TrackerEntityType_$reflection() {
    return union_type("Shared.Telematics.TrackerEntityType", [], TrackerEntityType, () => [[], []]);
}

export function TrackerEntityType__get_Key(this$) {
    if (this$.tag === 1) {
        return "set";
    }
    else {
        return "tool";
    }
}

export const TrackerEntityTypeModule_all = ofArray([new TrackerEntityType(0, []), new TrackerEntityType(1, [])]);

export function TrackerEntityTypeModule_tryParse(key) {
    return tryFind((entityType) => (TrackerEntityType__get_Key(entityType) === key), TrackerEntityTypeModule_all);
}

export class TelematicsConnectionDto extends Record {
    constructor(Id, Provider, ProviderHost, ApiKeyPrefix, VerifiedAt, LastError, LastErrorAt, UpdatedAt, ActiveAssignments) {
        super();
        this.Id = Id;
        this.Provider = Provider;
        this.ProviderHost = ProviderHost;
        this.ApiKeyPrefix = ApiKeyPrefix;
        this.VerifiedAt = VerifiedAt;
        this.LastError = LastError;
        this.LastErrorAt = LastErrorAt;
        this.UpdatedAt = UpdatedAt;
        this.ActiveAssignments = (ActiveAssignments | 0);
    }
}

export function TelematicsConnectionDto_$reflection() {
    return record_type("Shared.Telematics.TelematicsConnectionDto", [], TelematicsConnectionDto, () => [["Id", class_type("System.Guid")], ["Provider", TelematicsProvider_$reflection()], ["ProviderHost", string_type], ["ApiKeyPrefix", string_type], ["VerifiedAt", option_type(class_type("System.DateTime"))], ["LastError", string_type], ["LastErrorAt", option_type(class_type("System.DateTime"))], ["UpdatedAt", class_type("System.DateTime")], ["ActiveAssignments", int32_type]]);
}

export class TelematicsConnectionOverviewDto extends Record {
    constructor(ProviderHost, Connection) {
        super();
        this.ProviderHost = ProviderHost;
        this.Connection = Connection;
    }
}

export function TelematicsConnectionOverviewDto_$reflection() {
    return record_type("Shared.Telematics.TelematicsConnectionOverviewDto", [], TelematicsConnectionOverviewDto, () => [["ProviderHost", string_type], ["Connection", option_type(TelematicsConnectionDto_$reflection())]]);
}

export class SaveTelematicsConnectionDto extends Record {
    constructor(Provider, ApiKey) {
        super();
        this.Provider = Provider;
        this.ApiKey = ApiKey;
    }
}

export function SaveTelematicsConnectionDto_$reflection() {
    return record_type("Shared.Telematics.SaveTelematicsConnectionDto", [], SaveTelematicsConnectionDto, () => [["Provider", TelematicsProvider_$reflection()], ["ApiKey", option_type(string_type)]]);
}

export class TelematicsVerificationDto extends Record {
    constructor(TrackerCount) {
        super();
        this.TrackerCount = (TrackerCount | 0);
    }
}

export function TelematicsVerificationDto_$reflection() {
    return record_type("Shared.Telematics.TelematicsVerificationDto", [], TelematicsVerificationDto, () => [["TrackerCount", int32_type]]);
}

export class TelematicsConnectionDeletedDto extends Record {
    constructor(RemovedAssignments) {
        super();
        this.RemovedAssignments = (RemovedAssignments | 0);
    }
}

export function TelematicsConnectionDeletedDto_$reflection() {
    return record_type("Shared.Telematics.TelematicsConnectionDeletedDto", [], TelematicsConnectionDeletedDto, () => [["RemovedAssignments", int32_type]]);
}

export class TrackerMapConfigurationDto extends Record {
    constructor(GoogleMapsApiKey, GoogleMapsMapId) {
        super();
        this.GoogleMapsApiKey = GoogleMapsApiKey;
        this.GoogleMapsMapId = GoogleMapsMapId;
    }
}

export function TrackerMapConfigurationDto_$reflection() {
    return record_type("Shared.Telematics.TrackerMapConfigurationDto", [], TrackerMapConfigurationDto, () => [["GoogleMapsApiKey", option_type(string_type)], ["GoogleMapsMapId", option_type(string_type)]]);
}

export class TrackerPositionDto extends Record {
    constructor(Latitude, Longitude, RecordedAt, Heading, Fix, AccuracyMeters, Source) {
        super();
        this.Latitude = Latitude;
        this.Longitude = Longitude;
        this.RecordedAt = RecordedAt;
        this.Heading = Heading;
        this.Fix = Fix;
        this.AccuracyMeters = AccuracyMeters;
        this.Source = Source;
    }
}

export function TrackerPositionDto_$reflection() {
    return record_type("Shared.Telematics.TrackerPositionDto", [], TrackerPositionDto, () => [["Latitude", float64_type], ["Longitude", float64_type], ["RecordedAt", class_type("System.DateTime")], ["Heading", option_type(int32_type)], ["Fix", string_type], ["AccuracyMeters", option_type(int32_type)], ["Source", option_type(string_type)]]);
}

export class TrackerAssignmentInfoDto extends Record {
    constructor(EntityType, EntityId, EntityName, EntityInventoryNumber, AssignedAt) {
        super();
        this.EntityType = EntityType;
        this.EntityId = EntityId;
        this.EntityName = EntityName;
        this.EntityInventoryNumber = EntityInventoryNumber;
        this.AssignedAt = AssignedAt;
    }
}

export function TrackerAssignmentInfoDto_$reflection() {
    return record_type("Shared.Telematics.TrackerAssignmentInfoDto", [], TrackerAssignmentInfoDto, () => [["EntityType", TrackerEntityType_$reflection()], ["EntityId", class_type("System.Guid")], ["EntityName", string_type], ["EntityInventoryNumber", string_type], ["AssignedAt", class_type("System.DateTime")]]);
}

export class TrackerOverviewDto extends Record {
    constructor(TrackerId, Name, Imei, VendorSerial, Vendor, Model, Online, Disabled, LastSeenAt, Position, BatteryLow, Assignment) {
        super();
        this.TrackerId = TrackerId;
        this.Name = Name;
        this.Imei = Imei;
        this.VendorSerial = VendorSerial;
        this.Vendor = Vendor;
        this.Model = Model;
        this.Online = Online;
        this.Disabled = Disabled;
        this.LastSeenAt = LastSeenAt;
        this.Position = Position;
        this.BatteryLow = BatteryLow;
        this.Assignment = Assignment;
    }
}

export function TrackerOverviewDto_$reflection() {
    return record_type("Shared.Telematics.TrackerOverviewDto", [], TrackerOverviewDto, () => [["TrackerId", class_type("System.Guid")], ["Name", string_type], ["Imei", string_type], ["VendorSerial", option_type(string_type)], ["Vendor", string_type], ["Model", option_type(string_type)], ["Online", bool_type], ["Disabled", bool_type], ["LastSeenAt", option_type(class_type("System.DateTime"))], ["Position", option_type(TrackerPositionDto_$reflection())], ["BatteryLow", option_type(bool_type)], ["Assignment", option_type(TrackerAssignmentInfoDto_$reflection())]]);
}

export class TrackerOverviewPageDto extends Record {
    constructor(Connected, Trackers, LoadedAt) {
        super();
        this.Connected = Connected;
        this.Trackers = Trackers;
        this.LoadedAt = LoadedAt;
    }
}

export function TrackerOverviewPageDto_$reflection() {
    return record_type("Shared.Telematics.TrackerOverviewPageDto", [], TrackerOverviewPageDto, () => [["Connected", bool_type], ["Trackers", list_type(TrackerOverviewDto_$reflection())], ["LoadedAt", class_type("System.DateTime")]]);
}

export class TrackerAssignmentDto extends Record {
    constructor(Id, Provider, TrackerId, TrackerName, EntityType, EntityId, EntityName, AssignedAt, AssignedByUserId) {
        super();
        this.Id = Id;
        this.Provider = Provider;
        this.TrackerId = TrackerId;
        this.TrackerName = TrackerName;
        this.EntityType = EntityType;
        this.EntityId = EntityId;
        this.EntityName = EntityName;
        this.AssignedAt = AssignedAt;
        this.AssignedByUserId = AssignedByUserId;
    }
}

export function TrackerAssignmentDto_$reflection() {
    return record_type("Shared.Telematics.TrackerAssignmentDto", [], TrackerAssignmentDto, () => [["Id", class_type("System.Guid")], ["Provider", TelematicsProvider_$reflection()], ["TrackerId", string_type], ["TrackerName", string_type], ["EntityType", TrackerEntityType_$reflection()], ["EntityId", class_type("System.Guid")], ["EntityName", string_type], ["AssignedAt", class_type("System.DateTime")], ["AssignedByUserId", string_type]]);
}

export class AssignTrackerDto extends Record {
    constructor(TrackerId) {
        super();
        this.TrackerId = TrackerId;
    }
}

export function AssignTrackerDto_$reflection() {
    return record_type("Shared.Telematics.AssignTrackerDto", [], AssignTrackerDto, () => [["TrackerId", class_type("System.Guid")]]);
}

export class AssignedTrackerStatusDto extends Record {
    constructor(Imei, Online, Disabled, LastSeenAt, Position, BatteryLow, TrackingProfile) {
        super();
        this.Imei = Imei;
        this.Online = Online;
        this.Disabled = Disabled;
        this.LastSeenAt = LastSeenAt;
        this.Position = Position;
        this.BatteryLow = BatteryLow;
        this.TrackingProfile = TrackingProfile;
    }
}

export function AssignedTrackerStatusDto_$reflection() {
    return record_type("Shared.Telematics.AssignedTrackerStatusDto", [], AssignedTrackerStatusDto, () => [["Imei", string_type], ["Online", bool_type], ["Disabled", bool_type], ["LastSeenAt", option_type(class_type("System.DateTime"))], ["Position", option_type(TrackerPositionDto_$reflection())], ["BatteryLow", option_type(bool_type)], ["TrackingProfile", option_type(string_type)]]);
}

export class AssignedTrackerDto extends Record {
    constructor(AssignmentId, TrackerId, Name, AssignedAt, AssignedByUserId, Status) {
        super();
        this.AssignmentId = AssignmentId;
        this.TrackerId = TrackerId;
        this.Name = Name;
        this.AssignedAt = AssignedAt;
        this.AssignedByUserId = AssignedByUserId;
        this.Status = Status;
    }
}

export function AssignedTrackerDto_$reflection() {
    return record_type("Shared.Telematics.AssignedTrackerDto", [], AssignedTrackerDto, () => [["AssignmentId", class_type("System.Guid")], ["TrackerId", string_type], ["Name", string_type], ["AssignedAt", class_type("System.DateTime")], ["AssignedByUserId", string_type], ["Status", option_type(AssignedTrackerStatusDto_$reflection())]]);
}

export class AssignedTrackersDto extends Record {
    constructor(Connected, ProviderAvailable, Trackers) {
        super();
        this.Connected = Connected;
        this.ProviderAvailable = ProviderAvailable;
        this.Trackers = Trackers;
    }
}

export function AssignedTrackersDto_$reflection() {
    return record_type("Shared.Telematics.AssignedTrackersDto", [], AssignedTrackersDto, () => [["Connected", bool_type], ["ProviderAvailable", bool_type], ["Trackers", list_type(AssignedTrackerDto_$reflection())]]);
}

export class TrackPointDto extends Record {
    constructor(Latitude, Longitude, RecordedAt, SpeedKmh, Heading, Ignition, AccuracyMeters, Source) {
        super();
        this.Latitude = Latitude;
        this.Longitude = Longitude;
        this.RecordedAt = RecordedAt;
        this.SpeedKmh = SpeedKmh;
        this.Heading = Heading;
        this.Ignition = Ignition;
        this.AccuracyMeters = AccuracyMeters;
        this.Source = Source;
    }
}

export function TrackPointDto_$reflection() {
    return record_type("Shared.Telematics.TrackPointDto", [], TrackPointDto, () => [["Latitude", float64_type], ["Longitude", float64_type], ["RecordedAt", class_type("System.DateTime")], ["SpeedKmh", option_type(int32_type)], ["Heading", option_type(int32_type)], ["Ignition", option_type(bool_type)], ["AccuracyMeters", option_type(int32_type)], ["Source", option_type(string_type)]]);
}

export class TrackHistoryDto extends Record {
    constructor(TrackerId, From, To, Points, Resolution) {
        super();
        this.TrackerId = TrackerId;
        this.From = From;
        this.To = To;
        this.Points = Points;
        this.Resolution = Resolution;
    }
}

export function TrackHistoryDto_$reflection() {
    return record_type("Shared.Telematics.TrackHistoryDto", [], TrackHistoryDto, () => [["TrackerId", class_type("System.Guid")], ["From", class_type("System.DateTime")], ["To", class_type("System.DateTime")], ["Points", list_type(TrackPointDto_$reflection())], ["Resolution", string_type]]);
}

